export class Business {
    id: number | undefined;
    shopNumber: string = '';
    ownerName: string = '';
    ownerContactNumber: string = '';
    ownerWhatsApp: string = '';
    businessName: string = '';
    businessContactNumber: string = '';
    businessWhatsApp: string = '';
    businessDescription: string = '';
    imageUrl: string = '';
    electricityServiceNumber:string = '';
    contractSignedOn: Date = new Date();
    lastUpdatedOn: Date = new Date();
    leaseLength: number = 0;
    isVacant: boolean = false;

    get isNew(): boolean {
      return this.id === undefined;
    }
  
    constructor(data?: any) {
      if (!data) return;
      this.id = data?.id;
      this.shopNumber = data?.shopNumber!;
      this.ownerName = data?.ownerName!;
      this.ownerContactNumber = data?.ownerContactNumber!;
      this.ownerWhatsApp = data?.ownerWhatsApp;
      this.businessName = data?.businessName ?? '';
      this.businessContactNumber = data?.businessContactNumber!;
      this.businessWhatsApp = data?.businessWhatsApp;
      this.businessDescription = data?.businessDescription!;
      this.imageUrl = data?.imageUrl!;
      this.electricityServiceNumber = data?.electricityServiceNumber;
      if (data.contractSignedOn) {
        this.contractSignedOn = new Date(data.contractSignedOn);
      }
      if (data.lastUpdatedOn) {
        this.lastUpdatedOn = new Date(data.lastUpdatedOn);
      }
      this.leaseLength = data?.leaseLength!;
      this.isVacant = data?.isVacant!;
    }
  }